module.exports = __webpack_public_path__ + "img/sms-preview-header.ae51df8.png";